import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { updateQuantity, removeFromCart, updateTotalAmount } from '../../reducers/cart';
import { Link } from 'react-router-dom';

const CartSidebar = ({ isOpen, closeSidebar }) => {
    const dispatch = useDispatch();
    const cart = useSelector(state => state.cart?.items || []);
    const totalAmount = useSelector(state => state.cart?.totalAmount || '0.00');

    // useEffect(() => {
    //     sessionStorage.setItem('cart', JSON.stringify(cart));
    //     dispatch(updateTotalAmount(cart.reduce((sum, item) => sum + Number(item?.subTotal || 0), 0).toFixed(2)));
    // }, [cart, dispatch]);

useEffect(() => {
    const total = cart.reduce(
        (sum, item) => sum + Number(item?.subTotal || 0),
        0
    );

    dispatch(updateTotalAmount(total.toFixed(2)));
}, [cart, dispatch]);


    const updateQty = (item, qty) => {
        if (qty < 1) return;
        dispatch(updateQuantity({
            product_id: item.product_id,
            attribute_value_id: item.attribute_value_id,
            quantity: qty
        }));
    };

    const remove = item => dispatch(removeFromCart({
        product_id: item.product_id,
        attribute_value_id: item.attribute_value_id
    }));

    return (
        <>
            {isOpen && <div className="cart-overlay" onClick={closeSidebar} />}

            <div className={`cart-sidebar ${isOpen ? 'open' : ''}`}>
                <div className="cart-header">
                    <div>
                        <h5>Your Shopping Cart</h5>
                        <span>{cart.length} {cart.length === 1 ? 'item' : 'items'}</span>
                    </div>
                    <button className="cart-close" onClick={closeSidebar}>
                        <i className="fa fa-times" />
                    </button>
                </div>

                <div className="cart-drawer">
                    <Container fluid>
                        {cart.length ? (
                            <>
                                <div className="cart-items">
                                    {cart.map((item, index) => (
                                        <div className="cart-item" key={`${item.product_id}-${item.attribute_value_id}-${index}`}>
                                            <div className="cart-product-image">
                                                <img src={item?.product_thumbnail || ''} alt={item?.product_name || 'Product'} />
                                            </div>

                                            <div className="cart-product-info">
                                                <div className="cart-product-top">
                                                    <div>
                                                        <h6>{item?.product_name || 'Product'}</h6>
                                                        {item?.size && <span className="cart-size">Size: {item.size}</span>}
                                                    </div>
                                                    <button className="cart-remove" onClick={() => remove(item)}>
                                                        <i className="fa fa-trash-o" />
                                                    </button>
                                                </div>

                                                <div className="cart-product-bottom">
                                                    <div className="cart-qty">
                                                        <button disabled={Number(item.quantity || 0) <= 1} onClick={() => updateQty(item, Number(item.quantity) - 1)}>−</button>
                                                        <span>{item?.quantity || 0}</span>
                                                        <button onClick={() => updateQty(item, Number(item.quantity) + 1)}>+</button>
                                                    </div>

                                                    <div className="cart-price">
                                                        <small>₹{Number(item?.product_MRP || 0).toFixed(2)}</small>
                                                        <strong>₹{Number(item?.subTotal || 0).toFixed(2)}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="cart-summary">
                                    <div className="summary-row">
                                        <span>Subtotal</span>
                                        <strong>₹{Number(totalAmount).toFixed(2)}</strong>
                                    </div>
                                    <div className="summary-note">
                                        <i className="fa fa-shield" /> Secure checkout &amp; safe payment
                                    </div>
                                </div>

                                <div className="cart-footer">
                                    <Link to="/cart" className="cart-view-btn" onClick={closeSidebar}>View Cart</Link>
                                    <Link to="/checkout" className="cart-checkout-btn" onClick={closeSidebar}>
                                        <span>Checkout</span>
                                        <span>₹{Number(totalAmount).toFixed(2)}</span>
                                    </Link>
                                </div>
                            </>
                        ) : (
                            <div className="cart-empty">
                                <div className="empty-icon"><i className="fa fa-shopping-bag" /></div>
                                <h4>Your cart is empty</h4>
                                <p>Looks like you haven't added anything to your cart yet.</p>
                                <Link to="/" className="empty-shop-btn" onClick={closeSidebar}>Continue Shopping</Link>
                            </div>
                        )}
                    </Container>
                </div>
            </div>

            <style>{`
                .cart-overlay{position:fixed;inset:0;background:rgba(0,0,0,.42);z-index:9998;backdrop-filter:blur(2px)}
                .cart-sidebar{position:fixed;top:0;right:-440px;width:420px;max-width:100%;height:100vh;background:#fff;z-index:9999;display:flex;flex-direction:column;box-shadow:-8px 0 30px rgba(0,0,0,.12);transition:right .3s ease}
                .cart-sidebar.open{right:0}
                .cart-header{min-height:76px;padding:16px 20px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #eee}
                .cart-header h5{margin:0 0 3px;font-size:17px;font-weight:700;color:#222}
                .cart-header span{color:#888;font-size:12px}
                .cart-close{width:36px;height:36px;border:0;border-radius:50%;background:#f5f5f5;color:#555;cursor:pointer}
                .cart-close:hover{background:#222;color:#fff}
                .cart-drawer{flex:1;overflow-y:auto;padding:14px 12px 20px}
                .cart-drawer::-webkit-scrollbar{width:4px}
                .cart-drawer::-webkit-scrollbar-thumb{background:#ccc;border-radius:10px}
                .cart-items{display:flex;flex-direction:column;gap:10px}
                .cart-item{display:flex;gap:12px;padding:11px;border:1px solid #eee;border-radius:10px;background:#fff}
                .cart-product-image{width:78px;height:92px;flex:0 0 78px;border-radius:8px;background:#f7f7f7;overflow:hidden;display:flex;align-items:center;justify-content:center}
                .cart-product-image img{width:100%;height:100%;object-fit:cover}
                .cart-product-info{flex:1;min-width:0;display:flex;flex-direction:column;justify-content:space-between;gap:10px}
                .cart-product-top{display:flex;justify-content:space-between;gap:8px}
                .cart-product-top h6{margin:0;font-size:13px;line-height:18px;font-weight:600;color:#222;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
                .cart-size{display:block;margin-top:3px;color:#888;font-size:11px}
                .cart-remove{border:0;background:transparent;color:#aaa;padding:2px 4px;cursor:pointer}
                .cart-remove:hover{color:#dc3545}
                .cart-product-bottom{display:flex;align-items:center;justify-content:space-between;gap:10px}
                .cart-qty{display:flex;align-items:center;border:1px solid #ddd;border-radius:6px;height:30px;overflow:hidden}
                .cart-qty button{width:29px;height:30px;border:0;background:#fff;color:#333;font-size:16px;cursor:pointer}
                .cart-qty button:hover:not(:disabled){background:#f5f5f5}
                .cart-qty button:disabled{color:#ccc;cursor:not-allowed}
                .cart-qty span{min-width:27px;text-align:center;font-size:12px;font-weight:600}
                .cart-price{text-align:right;display:flex;flex-direction:column}
                .cart-price small{color:#999;font-size:10px;text-decoration:line-through}
                .cart-price strong{color:#222;font-size:14px;font-weight:700}
                .cart-summary{margin-top:15px;padding:15px 4px 10px;border-top:1px solid #eee}
                .summary-row{display:flex;justify-content:space-between;align-items:center;font-size:14px;color:#555}
                .summary-row strong{font-size:17px;color:#222}
                .summary-note{margin-top:9px;color:#888;font-size:11px}
                .summary-note i{margin-right:6px;color:#555}
                .cart-footer{display:grid;grid-template-columns:105px 1fr;gap:8px;padding:12px 4px 4px;background:#fff;position:sticky;bottom:0}
                .cart-view-btn,.cart-checkout-btn{height:46px;border-radius:7px;display:flex;align-items:center;justify-content:center;text-decoration:none;font-size:13px;font-weight:600}
                .cart-view-btn{border:1px solid #ddd;color:#333;background:#fff}
                .cart-view-btn:hover{color:#222;background:#f7f7f7}
                .cart-checkout-btn{padding:0 15px;justify-content:space-between;color:#fff;background:#222}
                .cart-checkout-btn:hover{color:#fff;background:#000}
                .cart-empty{min-height:calc(100vh - 110px);display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:30px}
                .empty-icon{width:85px;height:85px;border-radius:50%;background:#f6f6f6;display:flex;align-items:center;justify-content:center;color:#aaa;font-size:34px;margin-bottom:18px}
                .cart-empty h4{margin:0;font-size:18px;font-weight:700;color:#222}
                .cart-empty p{max-width:260px;margin:8px 0 20px;color:#999;font-size:12px;line-height:19px}
                .empty-shop-btn{padding:11px 20px;border-radius:6px;background:#222;color:#fff;text-decoration:none;font-size:12px;font-weight:600}
                .empty-shop-btn:hover{background:#000;color:#fff}
                @media(max-width:480px){.cart-sidebar{width:100%;right:-100%}.cart-header{padding:15px}.cart-drawer{padding:10px}.cart-product-image{width:70px;height:84px;flex-basis:70px}}
            `}</style>
        </>
    );
};

export default CartSidebar;

